export class CodeScanListItem {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.scanId = model.scanId;
        this.scanTimestamp = new Date(model.scanTimestamp);
        this.packageNames = model.packageNames;
        this.repositoryName = model.repositoryName;
        this.uploadedBy = model.uploadedBy;
        this.cliVersion = model.cliVersion;
    }
}
